import axios from "axios";

export const addUserToLocalStorage = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
}

export const removeUserFromLocalStorage = () => {
    const user_id = getUserFromLocalStorage().user_id;
    const localhost_env = localStorage.getItem('localhost_env');

    if (localhost_env) {
        axios.post('http://localhost:3001/pokeland-api/auth/logout/' + user_id);
    } else {
        axios.post('https://backend.pokeland-legends.club/pokeland-api/auth/logout/' + user_id);
    }

    localStorage.removeItem('user');
}

export const getUserFromLocalStorage = () => {
    const result = localStorage.getItem('user')
    const user = result ? JSON.parse(result) : false;
    return user;
}